import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { withRouter } from "react-router-dom";
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Page from '../Page/Page';
import { currency } from '../../utils';
import Placeholder from '../Placeholder/Placeholder';
import RefreshButton from '../RefreshButton/RefreshButton';
import InfoTile from '../InfoTile/InfoTile';
import Viivakoodi from '../Viivakoodi/Viivakoodi';
import VerottajaTili from './VerottajaTili';
import OmaveroStatusIcon from './OmaveroStatusIcon';
import DatePicker from '../DatePicker';


const OmaveroArvo = ({ data, tunnus, name }) => (
  <tr>
    <td className="inset">
      {name}
    </td>

    <td className="text-right">
      {
        (data && data.arvot ) ? currency( data.arvot.tunnus ? data.arvot.tunnus.VALUEFLOAT : 0) : <Placeholder size={4} />
      }
    </td>
  </tr>
);

const OmaveroTitle = ({ children }) => (
  <tr>
    <td colSpan="2">
      <Typography component={'span'} variant="body1" className="padding-md-top">
        {children}
      </Typography>
    </td>
  </tr>
);


@inject('omaveroStore')
@withRouter
@observer
class Omavero extends Component {
  componentDidMount() {
    this.props.omaveroStore.setCurrent(this.props.match.params.id, this.props.location.state);
  }

  render() {
    const { omaveroStore } = this.props;
    const item = omaveroStore.item;

    return (
      <Page
        title="Omavero"
        navigationAction={
          <IconButton
            onClick={omaveroStore.hide}
            color="inherit"
          >
            <CloseIcon />
          </IconButton>
        }
        actions={
          <div className="row">
            <RefreshButton
              loading={omaveroStore.isLoading}
              onClick={omaveroStore.refresh}
            />
          </div>
        }
      >
        <div className="padding-md">
          <div className="row margin-md-vert padding-sm" style={{ justifyContent: 'center', alignItems: 'center' }}>
            <OmaveroStatusIcon data={item} />
            <Typography component={'span'} variant="h5" style={{ marginLeft: 8 }}>
              {
                item.KOHDEVUOSI ?
                  <span>{item.KOHDEVUOSI} / {item.KOHDEKAUSI} {item.korjaus && ' - Korjaus'}</span> :
                  <Placeholder size={4} />
              }
            </Typography>
          </div>

          <table className="full-width margin-md-vert">
            {
              item.tas &&
              <tbody>
                <OmaveroTitle>
                  Palkanlaskenta - Työnantajasuoritukset
                </OmaveroTitle>
                <OmaveroArvo data={item} tunnus="602" name="Ennakonpidätys" />
                <OmaveroArvo data={item} tunnus="606" name="Lähdevero" />
                <OmaveroArvo data={item} tunnus="610" name="Sosiaaliturvamaksu" />
              </tbody>
            }
            {
              item.alv &&
              <tbody>
                <OmaveroTitle>
                  Kirjanpito - Arvonlisäsuoritukset
                </OmaveroTitle>
                <OmaveroArvo data={item} tunnus="308" name="Maksettava alv" />
                <OmaveroArvo data={item} tunnus="S309" name="Muut oma-aloitteiset verot" />
                <OmaveroArvo data={item} tunnus="S310" name="Viivästysseuraamukset" />
              </tbody>
            }
            {
              !item.alv && !item.tas &&
              <tbody>
                <OmaveroTitle>
                  <Placeholder size={18} />
                </OmaveroTitle>
                <OmaveroArvo name={<Placeholder size={8} />} />
                <OmaveroArvo name={<Placeholder size={8} />} />
                <OmaveroArvo name={<Placeholder size={8} />} />
              </tbody>
            }

            <tbody>
              <OmaveroTitle>
                OmaVero
              </OmaveroTitle>
              <OmaveroArvo data={item} tunnus="S1001" name="Käytettävissä oleva saldo" />
            </tbody>
          </table>

          <div className="padding-md-vert">
            <Divider />
          </div>

          <div className="row" style={{ justifyContent: 'space-around' }}>
            <InfoTile title="Saaja" value="Verohallinto" />
            <InfoTile title="Summa" value={currency(item.YHTEENSA)} />
          </div>

          {
            item.ilmoitusvaihe !== 'KESKEN' &&
            <div>
              <div className="row" style={{ justifyContent: 'space-around' }}>
                <InfoTile title="Tili" value={<VerottajaTili />} />
                <InfoTile title="Viite" value={item.OMAVEROVIITE} placeholderSize={8} />
              </div>

              <InfoTile title="IBAN" value={omaveroStore.verottajaIban} placeholderSize={10} />

              <InfoTile title="Eräpäivä" value={
                omaveroStore.erapvm &&
                <DatePicker
                  value={omaveroStore.erapvm}
                  format="dd.MM.yyyy"
                  onChange={omaveroStore.setErapvm}
                  clearable={false}
                  style={{ width: 100 }}
                />
              } />

              {
                item.OMAVEROVIITE && omaveroStore.verottajaIban &&
                <Viivakoodi
                  summa={item.YHTEENSA}
                  viite={item.OMAVEROVIITE}
                  iban={omaveroStore.verottajaIban}
                  erapvm={omaveroStore.erapvm}
                />
              }
            </div>
          }
        </div>
      </Page>
    );
  }
}

export default Omavero;
